import { Column, Row } from '@/components'
import { Button } from '@surein/ui'
import styled, { css } from 'styled-components'
import { prop } from 'styled-tools'

const blurStyles = css`
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(6px);
    border-radius: 16px;
  }
`

export const KPIOverviewContainer = styled(Column)<{
  hasDetailsLink?: boolean
  shouldBlur?: boolean
}>`
  width: 100%;
  border: 1px solid ${(props) => props.theme.color.b30};
  border-radius: 16px;
  align-items: center;
  gap: 24px;
  padding: 12px 24px;
  position: relative;
  background-color: ${(props) => props.theme.color.b0};
  padding-bottom: ${({ hasDetailsLink }) => (hasDetailsLink ? '48px' : '12px')};
  top: 0;

  > button {
    position: absolute;
    bottom: 8px;
    right: 16px;
    svg {
      height: 10px;
      width: 10px;

      > path {
        stroke: ${(props) => props.theme.color.info1};
      }
    }
  }

  ${({ shouldBlur }) => shouldBlur && blurStyles}
`

export const KPIChartContainer = styled(Column)`
  height: 200px;
  width: 280px;
  max-height: 100%;
  border-radius: 8px;
  position: relative;
  justify-content: center;
  min-width: 0;

  > div {
    height: 100% !important;
  }
`

export const CustomTooltipComponent = styled(Row)`
  background-color: white;
  padding: 8px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  align-items: center;
  gap: 4px;

  > span {
    white-space: nowrap;
  }
`

export const KPILegendContainer = styled(Column)`
  width: 100%;
  justify-content: center;
  gap: 8px;
`

export const KPILegendItem = styled(Row)`
  justify-content: space-between;
  gap: 8px;
`

export const KPILegendColor = styled.div`
  background-color: ${prop('color')};
  height: 12px;
  width: 12px;
  border-radius: 50%;
  margin-right: 4px;
  flex-shrink: 0;
`

export const MiddleTextWrapper = styled(Column)`
  position: absolute;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  width: 100%;
  gap: 8px;
  pointer-events: none;

  > span:first-child {
    font-size: 10px;
    color: ${(props) => props.theme.color.b50};
  }

  > span:last-child {
    font-weight: 700;
    font-size: 10px;
    color: ${(props) => props.theme.color.b50};
  }
`

export const KpiEmptyStateTextContainer = styled(Column)`
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  width: 100%;
  gap: 8px;
  padding: 16px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
`

export const KpiEmptyStateButton = styled(Button)`
  color: ${(props) => props.theme.color.electric500} !important;

  > span {
    color: ${(props) => props.theme.color.electric500} !important;
  }
`
